/* eslint-disable max-len */
var UI_WARNING = {
  "default": 'M31.89,30.55l-15-30a1,1,0,0,0-1.78,0l-15,30a1,1,0,0,0,0,1A1,1,0,0,0,1,32H31a1,1,0,0,0,.89-1.45ZM16,3.24,29.38,30H2.62ZM17,13.3v7.5a1,1,0,0,1-2,0V13.3a1,1,0,0,1,2,0Zm0,11.36v.5a1,1,0,0,1-2,0v-.5a1,1,0,1,1,2,0Z',
  globetrotter: 'M15 20.5V11.3M28.5 28.5H1.5L15 1.5L28.5 28.5ZM14.55 23.95C14.55 23.7 14.75 23.5 15 23.5C15.25 23.5 15.45 23.7 15.45 23.95C15.45 24.2 15.25 24.4 15 24.4C14.75 24.4 14.55 24.2 14.55 23.95Z'
};

export { UI_WARNING };
//# sourceMappingURL=UI_WARNING.js.map
